import React from 'react';
import styled from 'styled-components';

const BADGE_COLORS = {
  DRAFT: { bg: '#FFF3CD', color: '#856404' },
  PUBLISHED: { bg: '#D4EDDA', color: '#155724' },
  ARCHIVED: { bg: '#E2E3E5', color: '#383D41' },
};

const Badge = styled.span`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
  background: ${({ $bg }) => $bg};
  color: ${({ $color }) => $color};
  text-transform: uppercase;
`;

function StatusBadge({ status }) {
  const colors = BADGE_COLORS[status] || BADGE_COLORS.DRAFT;

  return (
    <Badge $bg={colors.bg} $color={colors.color}>
      {status || 'DRAFT'}
    </Badge>
  );
}

export default StatusBadge;
